/**
 * 创建人：袁俊双
 * 时间：2020-06-09
 * 描述：toolbar中的面包屑导航组件
 * 使用说明: 参考 sw-crumbs 配置应用说明文档
 * 更新记录: 
 */
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'sw-crumbs',
  templateUrl: './sw-crumbs.component.html',
  styleUrls: ['./sw-crumbs.component.css']
})
export class SwCrumbsComponent implements OnInit {

  

  /**
   * 展示分级的面包屑,其值为面包屑的数组值
   */
  @Input() crumbs:any[] = []

  /**
   * 展示分级的面包屑,其值为根据 crumbs 的哪个字段来显示面包屑,
   */
  @Input() crumbsKeyWord:string

  /**
   * 将点击的导航数据抛出
   */
  @Output() selectData = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }

  /**
   * 点击某一级，将被点击的返回，且将新的面包屑数据返回，请在重新查询列表之后，将第二个参数直接赋给 crumbs 参数,或者点击
   * @ignore
   */
  clickCrumb(crumb,i){
    if(this.crumbs.length-1 == i){
      //如果点击的是面包屑最后一个数据的话的话，就直接返回
      this.return
    } else {
      // 点击某一级的时候，将该数据后面的数据全部删除,它本身不删
      this.crumbs.splice(i+1)
      let data = {
        selectData:crumb,
        newCrumbs:this.crumbs
      }
      // 抛出
      this.selectData.emit(data)

    }
  }

  /**
   * 是否显示列表 宫格
   * @ignore
   */
  return(){
    // 点击返回上一级的时候，将面包屑数组的最后一个元素删除，然后将新数组和新的最后一个元素抛出
    this.crumbs.splice(this.crumbs.length-1,1)
    let data = {
      selectData:this.crumbs[this.crumbs.length-1],
      newCrumbs:this.crumbs
    }
    // 抛出
    this.selectData.emit(data)

  }

}
